import { Product } from 'BrokerTsLib/src/enums'
import { ContractsExportForm } from '../carkulka/ContractsExportForm'

export const ContractsTravelExport = () => {
  return (
    <ContractsExportForm product={Product.TravelInsurance} />
  )
}
